import clsx from 'clsx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import SectionHead from '../../../../UI/SectionHead'
import NotificationItem, { hasNotificationLayout } from '../../../../UI/NotificationItem'

import http from '../../../../shared/http'
import { TApi, TRoutes } from '../../../../shared/const'

import styles from './style.module.scss'

/*
 * Die jüngsten Mitteilungen auf dem Dashboard.
 *
 * Das Dashboard beantwortet "wie steht mein Unternehmen da" — dazu gehört,
 * was seit dem letzten Besuch passiert ist. Bisher stand das nur hinter dem
 * Menüpunkt "Mitteilungen"; die Zahl an der Leiste sagt, dass es etwas gibt,
 * aber nicht was.
 *
 * Gezeigt werden drei Kurzfassungen (Text auf zwei Zeilen gekürzt, keine
 * Schaltflächen) — gehandelt und weitergelesen wird auf der Mitteilungsseite.
 * Als gelesen gilt hier nichts: Das tut erst das Öffnen der Seite, sonst wäre
 * die Zahl an der Leiste nach einem Blick aufs Dashboard weg.
 */

const LIMIT = 3

// Als Spalte neben zwei anderen ist mehr Platz in der Höhe als in der Breite —
// dort stehen fünf statt drei.
const LIMIT_SPALTE = 5

function NotificationsPreview(props) {
	const { t } = useTranslation()
	const [notifications, setNotifications] = useState([])
	const [activationsStatus, setActivationsStatus] = useState(null)

	const limit = props.embedded ? LIMIT_SPALTE : LIMIT

	useEffect(() => {
		http.get(TApi.COMMON_GET_NOTIFICATIONS, { params: { limit, offset: 0 } }).then(({ data }) =>
			setNotifications((data.rows || []).filter(item => hasNotificationLayout(item.type)))
		)
		http.get(TApi.COMMON_ACTIVATED_STATUS).then(({ data }) => setActivationsStatus(data))
		/* eslint-disable-next-line */
	}, [limit])

	/*
	 * Ohne eine einzige Mitteilung bleibt der Block weg — ein leerer Kasten
	 * untereinander ist nur Fläche.
	 *
	 * Als **Spalte** gilt das nicht: Dort würde eine von drei Spalten
	 * verschwinden und die beiden anderen rutschten unter der Überschrift
	 * hervor. Steht sie in der Reihe, sagt sie stattdessen, dass es nichts gibt.
	 */
	if (!notifications.length && !props.embedded) return null

	return (
		<section className={clsx(styles.root, props.embedded ? styles.embedded : 'container', props.className)}>
			{/* Dieselbe Überschrift wie in jedem anderen Abschnitt — siehe UI/SectionHead. */}
			<SectionHead
				className={styles.header}
				title={t('Messages')}
				count={props.unreadCount}
				linkTo={TRoutes.NOTIFICATIONS}
				linkLabel={t('To all messages')}
			/>

			{!notifications.length && <p className={styles.empty}>{t('No messages yet')}</p>}

			<div className={styles.list}>
				{notifications.map(item => (
					<NotificationItem
						compact
						key={item.id}
						notification={{
							createdAt: item.createdAt,
							info: item.info,
							type: item.type,
							isViewed: item.isViewed
						}}
						activationsStatus={activationsStatus}
					/>
				))}
			</div>
		</section>
	)
}

NotificationsPreview.propTypes = {
	className: PropTypes.string,
	unreadCount: PropTypes.number,
	// Als Spalte im Dashboard-Raster statt als eigener Abschnitt über die Breite.
	embedded: PropTypes.bool
}

const mapStateToProps = state => ({
	unreadCount: state.user.profile.notifications?.messages || 0
})

export default connect(mapStateToProps)(NotificationsPreview)
